export function formatDateToPlanDay(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}${month}${day}`;
}

export function formatDateToPlannedDayHour(date: Date, hour: string | number): string {
  const planDay = formatDateToPlanDay(date);
  const hourStr = String(hour).padStart(2, "0");
  return `${planDay}${hourStr}`;
}

// Worksheets flagged with prepDayBefore are prepped one day ahead, so they show the next day's plan.
export function getPlanDayForWorksheet(
  date: Date,
  prepDayBefore?: boolean,
): string {
  if (!prepDayBefore) {
    return formatDateToPlanDay(date);
  }
  const nextDay = new Date(date);
  nextDay.setDate(nextDay.getDate() + 1);
  return formatDateToPlanDay(nextDay);
}

export function generateNextDays(numDays: number = 7): string[] {
  const days: string[] = [];
  const today = new Date();

  for (let i = 0; i < numDays; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    days.push(formatDateToPlanDay(date));
  }

  return days;
}

export function formatDateForDisplay(date: Date, translate?: (key: any) => string): string {
  if (translate) {
    const weekdayKeys = ["common.dates.weekdaysShort.sun", "common.dates.weekdaysShort.mon", "common.dates.weekdaysShort.tue", "common.dates.weekdaysShort.wed", "common.dates.weekdaysShort.thu", "common.dates.weekdaysShort.fri", "common.dates.weekdaysShort.sat"];
    const monthKeys = ["common.dates.monthsFull.january", "common.dates.monthsFull.february", "common.dates.monthsFull.march", "common.dates.monthsFull.april", "common.dates.monthsFull.may", "common.dates.monthsFull.june", "common.dates.monthsFull.july", "common.dates.monthsFull.august", "common.dates.monthsFull.september", "common.dates.monthsFull.october", "common.dates.monthsFull.november", "common.dates.monthsFull.december"];
    
    const weekdayShort = translate(weekdayKeys[date.getDay()]);
    const day = date.getDate();
    const month = translate(monthKeys[date.getMonth()]);
    return `${weekdayShort} ${day} ${month}`;
  }

  const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  
  const weekdayShort = weekdays[date.getDay()].substring(0, 3);
  const day = date.getDate();
  const month = months[date.getMonth()];
  return `${weekdayShort} ${day} ${month}`;
}
